module.exports = __webpack_public_path__ + "static/media/be.27d8ca49.svg";